'use strict';

module.exports = () => {
    const $slider = $('.services__slider');
    const $tabs = $('.services__tabs-btn');

    let startX = 0;
    let startY = 0;
    let isScrolling = false;

    $slider.slick({
        slidesToShow: 1,
        arrows: true,
        dots: true,
        adaptiveHeight: true
    });

    $tabs.on('touchstart', function (e) {
        const touch = e.originalEvent.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        isScrolling = false;
    });

    $tabs.on('touchmove', function (e) {
        const touch = e.originalEvent.touches[0];
        const diffX = Math.abs(startX - touch.clientX);
        const diffY = Math.abs(startY - touch.clientY);

        if (diffX > 10 || diffY > 10) {
            isScrolling = true;
        }
    });

    $tabs.on('click', function (e) {
        if (isScrolling) {
            e.preventDefault();
            return;
        }

        const index = $(this).data('slide');
        $slider.slick('slickGoTo', index);
    });

    $slider.on('afterChange', function (event, slick, currentSlide) {
        $tabs.removeClass('active');
        $tabs.eq(currentSlide).addClass('active');
    });
};